<template><div><h1>VUX V2.1.1Rc.4 released</h1>
<h2><a href="/en/components/icon.html">Icon</a></h2>
<ul><li>[change] No more built-in `icon-big` classname, use `is-msg` instead. #988 @greedying</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] fix this.$slots undefined #1000 @asingingfish</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[feature] Support position setting. #973 @ LaiXuechao</li>
</ul>
<h2><a href="/en/components/x-icon.html">XIcon</a></h2>
<ul><li>[feature] new component</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.4-83.vue?2eeecbc0